import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Box } from '@gik/ui';
import Link from '@/components/Link';

export interface IPreviewSectionProps {
  children: React.ReactNode;
  boxLink: string;
  boxContent: React.ReactNode;
  className: string;
}

const blockName = 'preview-section';

export default function PreviewSection({
  boxLink,
  className,
  children,
  boxContent,
}: IPreviewSectionProps): React.ReactElement {
  const bem = bemBlock(blockName);

  return (
    <Link href={boxLink}>
      <a>
        <div className={bem(null, null, className)}>
          <div className={bem('content')}>{children}</div>
          <Box variant="primary" className={bem('overlay')}>
            {boxContent}
          </Box>
        </div>
      </a>
    </Link>
  );
}
